/* eslint-disable no-return-assign */
import React, {useState} from 'react';
import Trash from 'assets/svgs/actions/trash.svg';
import OutsideClickHandler from 'react-outside-click-handler';
import Countries from 'components/Countries';
import Actions from './Actions';
import Search from './Search';
import Labels from './Labels';
import messages from '../messages';

const Filters = ({
  onChange,
  selected,
  onAction,
  labels,
  pageType,
  countries,
}) => {
  const [isOpen, setIsOpen] = useState(false);

  const [currentFilters, setCurrentFilters] = useState({
    language: '',
    categoryId: '',
    searchKey: '',
    label: '',
    isTrashed: false,
    isCustom: false,
    pageType,
  });

  const handleChange = (key, value, isDefault) => {
    const newFilters = {...currentFilters};
    newFilters[key] = value;
    setCurrentFilters(newFilters);

    const validFilters = Object.entries(newFilters).reduce(
      (a, [k, v]) => (v ? ((a[k] = v), a) : a),
      {}
    );

    if (isDefault) {
      return;
    }

    const filters = {};
    Object.keys(validFilters).forEach((validKey) => {
      if (validKey === 'language') {
        filters[validKey] = validFilters[validKey].code;
      } else if (validKey === 'country') {
        filters[validKey] = validFilters[validKey]._id;
      } else {
        filters[validKey] = validFilters[validKey];
      }
    });
    onChange(filters);
  };

  return (
    <div className="d-flex align-items-center mt-4 filters-middle letop-view position-relative filters-container">
      <Actions selected={selected} onAction={onAction} />

      <Countries
        selected={currentFilters.country}
        onChange={(e) => {
          handleChange('country', e);
        }}
        list={countries}
      />

      <Search
        value={currentFilters.searchKey}
        onChange={(e) => {
          handleChange('searchKey', e);
        }}
      />

      <Labels
        selected={currentFilters.label}
        isOpen={isOpen}
        setIsOpen={setIsOpen}
      />
      <div className="actions-btn filter-item pr-0" style={{maxWidth: 200}}>
        <button
          type="button"
          onClick={(e) => {
            e.preventDefault();
            handleChange('isTrashed', !currentFilters.isTrashed);
          }}
          aria-expanded={currentFilters.isTrashed}
          className="collapsed text-capitalize  d-flex align-items-center justify-content-center"
        >
          <img src={Trash} className="mr-2" alt="" /> {messages.trash}
        </button>
      </div>

      {isOpen && (
        <div className="lable-dropdown w-100 p-4 position-absolute">
          <OutsideClickHandler onOutsideClick={() => setIsOpen(!isOpen)}>
            {labels.map((label) => (
              <span
                key={label.label}
                aria-hidden
                className="role-btn text-center text-white mr-2 mb-2 pointer"
                onClick={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                  handleChange('label', label);
                  setIsOpen(false);
                }}
              >
                <span style={{background: label.colour}} className="mb-2">
                  {label.label}
                </span>
              </span>
            ))}
          </OutsideClickHandler>
        </div>
      )}
    </div>
  );
};

export default Filters;
